import { withNamespaces } from 'react-i18next';
import { AvForm, AvField, AvRadioGroup, AvRadio} from "availity-reactstrap-validation";
import { useEffect, useState } from "react";
import { useMutation } from '@tanstack/react-query';

import { Row, Col, Tooltip, Label, Button, Alert, Progress, Card } from "reactstrap";
import { Link } from "react-router-dom";

import Password from '../../../../components/Fields/Password';

import { API_URL_GENERATE_RANDOM_USERNAME, API_URL_SIGN_IN, API_URL_CREATE_THIRD_PARTY_ACCOUNT, API_URL_FETCH_CAPTCHA } from '../../../../common/constants';

import { LOCAL_STORAGE_KEY_ACCESS_TOKEN } from "../../../../services/constants/LocalStorage";

import axios from 'axios';

import { connect } from "react-redux";

import {
    checkLogin,
    setUserAccessToken,
    appError,
    appLoadStatusChanged,
    authCurrentUser,
    logoutUser,
    loginUserSuccessful,
    changeWorkspace
  } from "../../../../store/actions";
import { toast } from 'react-toastify';
import ReportIncidenService from 'src/modules/data-protection/pages/admin/data-subject-request/components/api/ReportIncidenService';

const FollowUpForm = (props) => {
    const {
        t, 
        user, 
        token, 
        settings, 
        onBackButtonClicked, 
        onValidSubmit, 
        onDsrFollowUpDetailsChange,
        username,
        password,
        setUsername,
        setPassword
    } = props;
    
    const [authFormIsSubmiting, setAuthFormIsSubmiting] = useState(false);
    const [usernameTooltipOpen, setUsernameTooltipOpen] = useState(false);
    const [passwordTooltipOpen, setPasswordTooltipOpen] = useState(false);

    const [captchaFetched, setCaptchaFetched] = useState(false);
	const [captchaSrc, setCaptchaSrc] = useState("");
	const [captcha, setCaptcha] = useState("");


    const [selectedAuthType, setSelecedAuthType] = useState("register"); 

    const [repassword, setRepassword] = useState("");
    const [email, setEmail] = useState("");
    const [requesterType, setRequesterType] = useState("company");
    const [organizationName, setOrganizationName] = useState("");
    const [organizationWebsite, setOrganizationWebsite] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [emailDomainMismatch, setEmailDomainMismatch] = useState(false);
    const [emailDomainProofFile, setEmailDomainProofFile] = useState(null);
    const [emailDomainProof, setEmailDomainProof] = useState(null);
    const [blockFormSubmit, setBlockFormSubmit] = useState(false);
    const isDSR = window.location.href.includes("data-subject-request");
    const isCompanyRequester = requesterType === "company";

    const {
        mutate: checkEmailOrgDomainMutation
    } = useMutation({
        mutationKey: ["data-protection-dsr-check-email-org-domain"],
        mutationFn: async (payload) => {
            const service = ReportIncidenService.getInstance();
            return await service.checkEmailOrgDomain(payload);
        },
        onSuccess: (result) => {
            const isMismatch = result?.match === false;
            setEmailDomainMismatch(isMismatch);
            if (!isMismatch) {
                setEmailDomainProofFile(null);
                setEmailDomainProof(null);
            }
        }
    });

    const {
        mutate: uploadEmailDomainProofMutation,
        isLoading: emailDomainProofIsUploading
    } = useMutation({
        mutationKey: ["data-protection-dsr-upload-email-domain-proof"],
        mutationFn: async (file) => {
            const service = ReportIncidenService.getInstance();
            return await service.uploadEmailDomainProof(file);
        },
        onSuccess: (data) => {
            setEmailDomainProof(data?.id || null);
        },
        onError: () => {
            setEmailDomainProofFile(null);
            setEmailDomainProof(null);
            toast(t("An error occurred while uploading the file"), {
                type: "error"
            });
        }
    });

    const {
        mutate: deleteEmailDomainProofMutation
    } = useMutation({
        mutationKey: ["data-protection-dsr-delete-email-domain-proof"],
        mutationFn: async (attachmentId) => {
            const service = ReportIncidenService.getInstance();
            return await service.deleteEmailDomainProof(attachmentId);
        },
        onError: () => {
            // Soft cleanup — local state is already cleared.
        }
    });

    useEffect(() => {
        if(selectedAuthType === "login"){
            setUsername("");
        }
    }, [selectedAuthType]);

    useEffect(() => {
		if(selectedAuthType === "register") {
            fetchCaptcha();
		}
    }, [])

    useEffect(() => {
        if (!isDSR || selectedAuthType !== "register" || !onDsrFollowUpDetailsChange) {
            return;
        }

        if (isCompanyRequester) {
            onDsrFollowUpDetailsChange({
                requester_type: "company",
                organization_name: organizationName || null,
                organization_website: organizationWebsite || null,
                phone: phoneNumber || null,
                email_domain_mismatch: emailDomainMismatch,
                email_domain_proof: emailDomainProof || null,
            });
            return;
        }

        onDsrFollowUpDetailsChange({
            requester_type: "private_person",
            organization_name: null,
            organization_website: null,
            phone: phoneNumber || null,
            email_domain_mismatch: false,
            email_domain_proof: null,
        });
    }, [
        isDSR,
        selectedAuthType,
        isCompanyRequester,
        organizationName,
        organizationWebsite,
        phoneNumber,
        emailDomainMismatch,
        emailDomainProof,
        onDsrFollowUpDetailsChange,
    ]);

    const generateRandomUsername = () => {
        setUsername("");

        axios.get(API_URL_GENERATE_RANDOM_USERNAME + localStorage.getItem("i18nextLng"))
        .then((response) => {
            if (response.status === 200) {
                const { data : generatedUserName } = response.data;
                setUsername(generatedUserName);
            }
        });    
    };

    const clearEmailDomainProof = () => {
        setEmailDomainProofFile(null);
        setEmailDomainProof(null);
        resetEmailDomainProofInput();
    };

    const resetEmailDomainProofInput = () => {
        const input = document.getElementById("email_domain_proof");
        if (input) {
            input.value = "";
        }
    };

    const handleRequesterTypeChange = (nextType) => {
        setRequesterType(nextType);

        if (nextType === "private_person") {
            setOrganizationName("");
            setOrganizationWebsite("");
            setEmailDomainMismatch(false);
            clearEmailDomainProof();
        }
    };

    const checkEmailOrgDomain = (overrides = {}) => {
        if (!isDSR || selectedAuthType !== "register" || !isCompanyRequester) {
            return;
        }

        const emailValue = overrides.email ?? email;
        const websiteValue = overrides.organizationWebsite ?? organizationWebsite;

        if (!emailValue || !websiteValue) {
            setEmailDomainMismatch(false);
            clearEmailDomainProof();
            return;
        }

        checkEmailOrgDomainMutation({
            email: emailValue,
            organization_website: websiteValue,
        });
    };

    const handleChangeEmail = () => {
        const emailInput = document.getElementById("email");
        if (emailInput) {
            emailInput.focus();
            emailInput.select();
        }
    };

    const armFileDialogSubmitGuard = () => {
        setBlockFormSubmit(true);
        setTimeout(() => {
            setBlockFormSubmit(false);
        }, 500);
    };

    const handleEmailDomainProofChange = (e) => {
        e.preventDefault();
        e.stopPropagation();
        armFileDialogSubmitGuard();

        const file = e.target.files?.[0] || null;
        if (!file) {
            return;
        }

        if (emailDomainProof) {
            deleteEmailDomainProofMutation(emailDomainProof);
        }

        Object.assign(file, {
            preview: URL.createObjectURL(file),
            formattedSize: file.size,
        });

        setEmailDomainProofFile(file);
        setEmailDomainProof(null);
        uploadEmailDomainProofMutation(file);
    };

    const handleRemoveEmailDomainProof = () => {
        const proofId = emailDomainProof;
        clearEmailDomainProof();

        if (proofId) {
            deleteEmailDomainProofMutation(proofId);
        }
    };

    const renderAuthForm = () => {
        const emailIsRequired = selectedAuthType === "login" ? false : !!(settings?.inputs?.email?.required);

        return (
            <Row>
                <Col sm="12" className="mb-3">
                    <AvRadioGroup
                        defaultValue={ selectedAuthType }
                        name="auth_type"
                        validate={{ required: { value: true } }}
                        errorMessage={t("This field cannot be blank")}>
                        <Row>
                            <Col sm="12" md="6">
                                <AvRadio
                                    label={t("Log In")}
                                    onChange={() => setSelecedAuthType("login") }
                                    value="login"
                                />
                            </Col>

                            <Col sm="12" md="6">
                                <AvRadio
                                    label={t("Create account")}
                                    onChange={() => setSelecedAuthType("register") }
                                    value="register"
                                />
                            </Col>
                        </Row>
                    </AvRadioGroup>
                </Col>

                <Col sm="12" className="mb-3">
                    <Label className="form-label" htmlFor="username">
                        {`${t("Username")}`}
                        <span className="ms-2">
                            <i className="fa fa-info-circle"
                                aria-hidden="true"
                                id="infoIconU" />
                            <Tooltip
                                placement="top"
                                isOpen={ usernameTooltipOpen }
                                target="infoIconU"
                                toggle={() => setUsernameTooltipOpen(!usernameTooltipOpen) }>
                                {t(
                                    "Please choose a username that doesnt contain your name or any kind of email address"
                                )}
                            </Tooltip>
                        </span>

                        <Button
                            outline
                            hidden={selectedAuthType === "login"}
                            className="btn-sm ms-2"
                            onClick={ generateRandomUsername }>
                                {t("Random")}
                        </Button>
                    </Label>
                    
                    <AvField name="username"
                        placeholder=""
                        type="text"
                        className="form-control"
                        errorMessage={t("This field cannot be blank")}
                        onChange={(e) => setUsername(e.target.value)}
                        validate={{
                            required: { value: true },
                            pattern: {
                                value: /^[^@\s]+$/,
                                errorMessage: t("Please enter a valid username"),
                            },
                        }}
                        value={ username }
                        id="username" />
                </Col>

                <Col sm="12" className="mb-3">
                    <Label className="form-label" htmlFor="password">
                        {`${t("Password")}`}
                        <span className="ms-2">
                            <i
                                className="fa fa-info-circle"
                                aria-hidden="true"
                                id="infoIcon" />
                            <Tooltip
                                placement="top"
                                isOpen={ passwordTooltipOpen }
                                target="infoIcon"
                                toggle={() => setPasswordTooltipOpen(!passwordTooltipOpen)}>
                                    {t(
                                    "Please choose a password at least 10 characters contains 1 capital letter,1 digit, and 1 special character contains"
                                    ) +
                                    ": ! @ # $ % ^ & * ( ) _ [ ]+={ } ' \" ; : / ? . , < > |  -"}
                            </Tooltip>
                        </span>
                    </Label>

                    <Password
                        name="password"
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder=""
                        errorMessage={t("This field cannot be blank")}
                        validate={{ required: { value: true } }}
                        id="password"
                        value={ password } />
                </Col>
                
                {
                    selectedAuthType === 'register' && (
                        <>
                            <Col sm="12" className="mb-3">
                                <Label className="form-label" htmlFor="repeatpasword">
                                    {`${t("Repeat password")}`}
                                </Label>

                                <Password
                                    name="repeat_pasword"
                                    placeholder=""
                                    onChange={(e) => setRepassword(e.target.value)}
                                    className="form-control"
                                    value={ repassword }
                                    errorMessage={t("This field cannot be blank")}
                                    validate={{ required: { value: true } }}
                                    id="repeatpasword"
                                />
                            </Col>

                            {/* Captcha */}
                            <Col sm="12">
                            {captchaFetched && (
                                <>
                                    <div className="mt-3 mb-3">
                                        <img className="me-4" src={captchaSrc} alt="Captcha" />
                                        <i 
                                        className="ri-restart-line ri-2x"
                                        style={{ cursor: "pointer" }} 
                                        onClick={fetchCaptcha}
                                        ></i>
                                    </div>
                                    <AvField
                                        name="captcha"
                                        placeholder={t("Enter captcha")}
                                        type="text"
                                        className="form-control mb-3"
                                        errorMessage={t("This field cannot be blank")}
                                        validate={{
                                        required: { value: true },
                                        }}
                                        onChange={(e) => setCaptcha(e.target.value)}
                                        id="captcha"
                                    />
                                </>
                                
                            )}
                            </Col>
                        </>
                    )
                }

                {
                    selectedAuthType === 'register' && isDSR && (
                        <>
                            <Col sm="12" className="mb-3">
                                <Label className="form-label">
                                    {t("Submitting as")}
                                </Label>
                                <AvRadioGroup
                                    defaultValue={requesterType}
                                    name="requester_type"
                                    validate={{ required: { value: true } }}
                                    errorMessage={t("This field cannot be blank")}
                                >
                                    <Row>
                                        <Col sm="12" md="6">
                                            <AvRadio
                                                label={t("Company")}
                                                onChange={() => handleRequesterTypeChange("company")}
                                                value="company"
                                            />
                                        </Col>
                                        <Col sm="12" md="6">
                                            <AvRadio
                                                label={t("Private person")}
                                                onChange={() => handleRequesterTypeChange("private_person")}
                                                value="private_person"
                                            />
                                        </Col>
                                    </Row>
                                </AvRadioGroup>
                            </Col>

                            {isCompanyRequester && (
                                <>
                                    <Col sm="12" className="mb-3">
                                        <Label className="form-label" htmlFor="organization_name">
                                            {t("Organization")}
                                        </Label>

                                        <AvField
                                            name="organization_name"
                                            placeholder=""
                                            type="text"
                                            className="form-control"
                                            errorMessage={t("This field cannot be blank")}
                                            validate={{ required: { value: true } }}
                                            id="organization_name"
                                            value={organizationName}
                                            onChange={(e) => setOrganizationName(e.target.value)}
                                        />
                                    </Col>

                                    <Col sm="12" className="mb-3">
                                        <Label className="form-label" htmlFor="organization_website">
                                            {t("Organization Website")}
                                        </Label>

                                        <AvField
                                            name="organization_website"
                                            placeholder=""
                                            type="url"
                                            className="form-control"
                                            errorMessage={t("This field is invalid")}
                                            validate={{
                                                required: { value: true },
                                                url: true,
                                            }}
                                            id="organization_website"
                                            value={organizationWebsite}
                                            onChange={(e) => {
                                                setOrganizationWebsite(e.target.value);
                                                setEmailDomainMismatch(false);
                                                clearEmailDomainProof();
                                            }}
                                            onBlur={(e) => checkEmailOrgDomain({
                                                organizationWebsite: e.target.value,
                                            })}
                                        />
                                    </Col>
                                </>
                            )}

                            <Col sm="12" className="mb-3">
                                <Label className="form-label" htmlFor="phoneNumber">
                                    {`${t("Phone Number")} ${t("(Optional)")}`}
                                </Label>

                                <AvField
                                    name="phoneNumber"
                                    placeholder=""
                                    type="text"
                                    className="form-control"
                                    validate={{ required: { value: false } }}
                                    id="phoneNumber"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </Col>
                        </>
                    )
                }

                <Col sm="12" className="mb-3">
                    <Label className="form-label" htmlFor="email">
                        {`${t("Email")} ${!emailIsRequired ? t("(Optional)") : ''}`}
                    </Label>

                    <AvField
                        name="email"
                        placeholder=""
                        type="email"
                        className="form-control"
                        validate={{ required: { value: emailIsRequired }, email: true }}
                        errorMessage={ t("This field is invalid") }
                        id="email"
                        value={ email }
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setEmailDomainMismatch(false);
                            clearEmailDomainProof();
                        }}
                        onBlur={isDSR && selectedAuthType === "register" && isCompanyRequester
                            ? (e) => checkEmailOrgDomain({ email: e.target.value })
                            : undefined
                        }
                    />

                    {isDSR && selectedAuthType === "register" && isCompanyRequester && emailDomainMismatch && (
                        <Alert color="warning" className="mt-2 mb-0">
                            <p className="mb-2">
                                {t("Email domain does not match the organization website.")}
                            </p>
                            <p className="mb-2">
                                {t("Please change your email to a matching domain, or optionally upload proof that this email belongs to the company.")}
                            </p>
                            <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                                <Button
                                    color="warning"
                                    outline
                                    size="sm"
                                    type="button"
                                    onClick={handleChangeEmail}
                                >
                                    {t("Change email")}
                                </Button>
                            </div>
                            <div>
                                <Label className="form-label mb-1" htmlFor="email_domain_proof">
                                    {`${t("Proof that this email belongs to the company")} ${t("(Optional)")}`}
                                </Label>
                                <input
                                    type="file"
                                    name="email_domain_proof"
                                    id="email_domain_proof"
                                    className="form-control fileUpload"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        armFileDialogSubmitGuard();
                                    }}
                                    onChange={handleEmailDomainProofChange}
                                    disabled={emailDomainProofIsUploading}
                                />

                                <Progress
                                    color="info"
                                    striped
                                    animated
                                    value={100}
                                    hidden={!emailDomainProofIsUploading}
                                    className="mt-2"
                                >
                                    {t("Please wait while the file is uploaded")}
                                </Progress>

                                {emailDomainProofFile && !emailDomainProofIsUploading && (
                                    <div className="dropzone-previews mt-3" id="email-domain-proof-previews">
                                        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                            <div className="p-2">
                                                <Row className="align-items-center">
                                                    <Col>
                                                        <Link to="#" className="text-muted fw-bold">
                                                            {emailDomainProofFile.name}
                                                        </Link>
                                                        <p className="mb-0">
                                                            <strong>{emailDomainProofFile.formattedSize || emailDomainProofFile.size}</strong>
                                                        </p>
                                                    </Col>
                                                    <Col
                                                        xs={2}
                                                        style={{
                                                            textAlign: "right",
                                                        }}
                                                    >
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            type="button"
                                                            onClick={handleRemoveEmailDomainProof}
                                                        >
                                                            X
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Card>
                                    </div>
                                )}
                            </div>
                        </Alert>
                    )}
                </Col>
            </Row>
        );
    }

    const loginUser = (credentials) => {
        return axios.post(API_URL_SIGN_IN, credentials)
        .then((response) => {
            const authedUserInfos = response.data.data;
            
            localStorage.setItem(LOCAL_STORAGE_KEY_ACCESS_TOKEN, authedUserInfos.token);

            props.setUserAccessToken(authedUserInfos.token);

            props.loginUserSuccessful(authedUserInfos.profile);

            onValidSubmit && onValidSubmit({
                token   :   authedUserInfos.token
            });
        })
        .catch(( errorResponse ) => {
            toast(errorResponse.message, {
                type: "error"
            })
        })
        .finally(() => {
            setAuthFormIsSubmiting(false);
        });
    }

    const startAuthentication = () => {
        if (blockFormSubmit || emailDomainProofIsUploading) {
            return;
        }

        if(user){
            onValidSubmit({
                token
            });
        }
        else{
            setAuthFormIsSubmiting(true);
            if(selectedAuthType === 'login'){
                loginUser({
                    organization: props.Organization.id,
                    username: username,
                    password: password,
                    isThirdPartyUser: true,
                    "2fa": selectedAuthType === "register" && isDSR ? true : false
                });
            }
            else{
                const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\[\]+={}'";:/?.,<>|\\-]).{10,100}$/;

                if (!passwordRegex.test(password)) {
                    setAuthFormIsSubmiting(false);
                    return toast(t(
                        "Password should be at least 10 characters and should contain at least one uppercase letter, one lowercase letter, one number and one special character"
                    ), {
                        type: "error"
                    })
                } 
                else if (password !== repassword) {
                    setAuthFormIsSubmiting(false);
                    return toast(t(
                        "Password and repeat password are not the same"
                    ), {
                        type: "error"
                    })
                } 
                else {
                    axios.post(API_URL_CREATE_THIRD_PARTY_ACCOUNT, {
                            organization: props.Organization.id,
                            username: username,
                            password: password,
                            email: email || null,
                            isThirdPartyUser: true,
                            privacyPolicyAccepted: true,
                            userPolicyAccepted: true,
                            verifyCode: captcha,
                            ...(isDSR ? {
                                requester_type: requesterType,
                                ...(isCompanyRequester ? {
                                    organization_name: organizationName || null,
                                } : {}),
                                phoneNumber: phoneNumber || null,
                            } : {}),
                    }, {
                        withCredentials: true,
                    }).then(() => {             
                        loginUser({
                            organization: props.Organization.id,
                            username: username,
                            password: password,
                            isThirdPartyUser: true,
                            "2fa": selectedAuthType === "register" && isDSR ? true : false
                        });
                    }).catch((error) => {
                       
                        if (error.response && error.response?.data?.message?.email === "validation.email.already_used") {
                          
                            return toast(t(
                                "Email is already in use. Please try a different email."
                            ), {
                                type: "error"
                            }) 
                          } 

                        for (var key in error.response.data.message) {
                            if (error.response.data.message.hasOwnProperty(key)) {
                                return toast(t(
                                    error.response.data.message[key]
                                ), {
                                    type: "error"
                                })
                            }
                        }
                    }).finally(() => {
                        setAuthFormIsSubmiting(false);
                    });
                }
            }
        }
    }

    const fetchCaptcha = () => {
		axios
		  .get(API_URL_FETCH_CAPTCHA, {
			responseType: "json", 
			withCredentials: true,
		  })
		  .then((response) => {
			if (response && response.data && response.data.captcha) {
				setCaptchaFetched(true);
				setCaptchaSrc(response.data.captcha);
			}
		  })
		  .catch((error) => {
			toast(t("Error while fetching captcha"))
		  });
	  };

    return (
        <AvForm className="needs-validation"
            onValidSubmit={ startAuthentication }
            >
            {
                <Row>
                    <Col sm="12" md="6" lg="4">
                        <h5>{t("Follow-Up")}</h5>
                        <p>
                            {t(
                                "If you would like to receive updates regarding your report via email, please check your email address is correct in your account settings."
                            )}
                        </p>
                    </Col>
                    <Col sm="12" md="6" lg="8">
                        <Row>
                            { !user && renderAuthForm() }
                        </Row>
                    </Col>
                </Row> 
            }

            <Row>
                <Col sm="12" className="d-flex justify-content-between align-items-center col-sm-12">
                    <Button
                        disabled={ authFormIsSubmiting }
                        onClick={() => {
                            if(onBackButtonClicked){
                                onBackButtonClicked();
                            }
                        }}
                        color="btn btn-outline-light"
                        type="button">
                        {t(settings?.buttons?.back?.title || "Back")}
                    </Button>

                    <Button
                        disabled={ authFormIsSubmiting || blockFormSubmit || emailDomainProofIsUploading }
                        color="btn btn-primary"
                        type="submit">
                        {selectedAuthType === "register" && isDSR ? t("Next") : t(settings?.buttons?.confirm?.title || "Confirm")}
                    </Button>
                </Col>
            </Row>
        </AvForm>
    )
}

const mapStateToProps = (state) => {
    const { token, user } = state.Login;
    const { Organization, App } = state;

    return { token, Organization, user, App };
};

export default withNamespaces()(
    connect(mapStateToProps, {
        logoutUser,
        checkLogin,
        loginUserSuccessful,
        authCurrentUser,
        changeWorkspace,
        appError,
        appLoadStatusChanged,
        setUserAccessToken,
    })(FollowUpForm)
);